import { Type } from '@angular/core';
import { UserInfoComponent } from '../user-info/user-info.component';
import { FieldActivityLogComponent } from '../field-activity-log/field-activity-log.component';
import { AttentionComponent } from '../check-sheet/attention/attention.component';
import { TrainingComponent } from '../check-sheet/training/training.component';
import { MealComponent } from '../check-sheet/meal/meal.component';
import { BatsuMaruComponent } from '../check-sheet/batsu-maru/batsu-maru.component';
import { YesNoIndicatorComponent } from '../check-sheet/yes-no-indicator/yes-no-indicator.component';
import { TextMarqueeComponent } from '../text-marquee/text-marquee.component';
import { DynamicLabelComponent } from '../dynamic-label/dynamic-label.component';
import { LeaveComponent } from '../leave/leave.component';
import { StatusComponent } from '../status/status.component';
import { FinalTreatmentComponent } from '../final-treatment/final-treatment.component';
import { DualBarChartComponent } from '../dual-bar-chart/dual-bar-chart.component';
import { FieldActivityHeaderComponent } from '../field-activity-log/field-activity-header/field-activity-header.component';
import { ShowcaseComponent } from '../showcase/showcase.component';
import { FieldActivityHeaderMonthComponent } from '../field-activity-log/field-activity-header-month/field-activity-header-month.component';
import { MealMoistureComponent } from '../check-sheet/meal-moisture/meal-moisture.component';
import { MealSnackComponent } from '../check-sheet/meal-snack/meal-snack.component';

export const COMPONENT_NAME = {
	UserInfoComponent: 'UserInfoComponent',
	FieldActivityLogComponent: 'FieldActivityLogComponent',
	VitalComponent: 'VitalComponent',
	AttentionComponent:'AttentionComponent',
	TrainingComponent:'TrainingComponent',
	MealComponent: 'MealComponent',
	MealMoistureComponent:'MealMoistureComponent',
	YesNoIndicatorComponent: 'YesNoIndicatorComponent',
	BatsuMaruComponent: 'BatsuMaruComponent',
	TextMarqueeComponent: 'TextMarqueeComponent',
	DynamicLabelComponent: 'DynamicLabelComponent',
	LeaveComponent:'LeaveComponent',
	StatusComponent:'StatusComponent',
	DualBarChartComponent: 'DualBarChartComponent',
	FinalTreatmentComponent: 'FinalTreatmentComponent',
	FieldActivityHeaderComponent: 'FieldActivityHeaderComponent',
	FieldActivityHeaderMonthComponent: 'FieldActivityHeaderMonthComponent',
	MealSnackComponent: 'MealSnackComponent',
}

export const ComponentMap: Record<string, Type<any>> = {
	[COMPONENT_NAME.UserInfoComponent] : UserInfoComponent,
	[COMPONENT_NAME.FieldActivityLogComponent]: FieldActivityLogComponent,
	[COMPONENT_NAME.VitalComponent]: ShowcaseComponent,
	[COMPONENT_NAME.AttentionComponent]: AttentionComponent,
	[COMPONENT_NAME.TrainingComponent]: TrainingComponent,
	[COMPONENT_NAME.MealComponent]: MealComponent,
	[COMPONENT_NAME.MealMoistureComponent]: MealMoistureComponent,
	[COMPONENT_NAME.YesNoIndicatorComponent]: YesNoIndicatorComponent,
	[COMPONENT_NAME.BatsuMaruComponent]: BatsuMaruComponent,
	[COMPONENT_NAME.TextMarqueeComponent]: TextMarqueeComponent,
	[COMPONENT_NAME.DynamicLabelComponent]:DynamicLabelComponent,
	[COMPONENT_NAME.LeaveComponent]:LeaveComponent,
	[COMPONENT_NAME.StatusComponent]:StatusComponent,
	[COMPONENT_NAME.DualBarChartComponent]:DualBarChartComponent,
	[COMPONENT_NAME.FinalTreatmentComponent]: FinalTreatmentComponent,
	[COMPONENT_NAME.FieldActivityHeaderComponent]: FieldActivityHeaderComponent,
	[COMPONENT_NAME.FieldActivityHeaderMonthComponent]: FieldActivityHeaderMonthComponent,
	[COMPONENT_NAME.MealSnackComponent]: MealSnackComponent,
};
